/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from "react";
import styled from "styled-components";
import { MainLayout } from "layouts";
import { PAGE_TYPES } from "config";
import {
  PageDropDown,
  AdBlockDropDown,
  Card,
  OfferSelector,
  AdblockLocation,
  Link,
  AdblockImage,
  AdblockApproved,
  ManualEntry,
  EventsDropDown,
  QuickSelectionChoice,
  OfferItem,
  IncentiveItem,
  OfferTextBuilder,
  IncentiveTextBuilder,
  NoSuggestions,
  QuickSelection,
  MetaData,
  PageInfo,
  FlagButtonGroup,
  EmptyOfferSelector,
  Button,
  NetUnitPriceModal,
  OfferInfoContainer,
} from "components";
import { INIT_OFFER_TEXT } from "config";
import { IncentiveInfo, OfferInfo, EmptyInfo } from "fragments";
import { useMainContext } from "contexts";
import { EndQueueModal, ImageMatchingModal, OfferDeletionModal } from "modals";
import { ConfirmationModal } from "modals/commons/ConfirmationModal";
import { SpaceAfterSlashWarningModal } from "modals/commons/SpaceAfterSlashWarningModal";
import {
  getImage,
  approveOffer,
  getOfferTypesApi,
  updateAdblockSuggestions,
  skipAdblock,
  doNotEnterAdblock,
  getCircularById,
  saveCircularIncentives,
  savePageIncentives,
  rejectAdblock,
  getSimilarAdBlockOffers,
  getCurrentUserAPI,
  getAdBlockById,
  getPageCrops,
  getPageIncentive,
  getCircularIncentive,
  getProductSizesApi,
  unApproveOffer,
  getOfferValuesApi,
  resetAdblock,
  overrideAdblock,
  markAdblockToReview,
  getRetailerAutocompleteApi,
  getCloningApi,
} from "api";
import { SearchByMultipleRetailer } from "pages/Filters/Components/SearchByMultipleRetailer";
import { 
  extractTextBetweenFirstBalancedParenthesis, 
  getIncentiveInfo,
  validateIncentive, 
  validateOffer, 
  setCachedImage, 
  getCachedImage, 
  offerValidationSchema,
  standardizeText,
  sortAdblocksByStatus,
  checkSpaceAfterSlash
} from "utils";
import { useInput, useModal } from "hooks";
import { useParams, navigate } from "@reach/router";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { omit } from "lodash";
import useKeypress from "react-use-keypress";
import { useAuthContext } from "contexts";
import { format } from "date-fns";
import {
  OFFER_SUGGESTION_TITLE,
  INCENTIVE_SUGGESTION_TITLE,
  OFFER_INIT_SUGGESTIONS,
  OFFER_INIT_INFO,
  INCENTIVE_INIT_SUGGESTION,
  INCENTIVE_INIT_INFO,
  INCENTIVE_INFO_FIELDS,
  OFFER_INFO_FIELDS,
  INIT_OFFER_METADATA,
  EXTRA_INCENTIVE_SUGGESTIONS,
} from "config";
import { isCraftBeerBogoViolation, CRAFT_BEER_BOGO_MESSAGE } from "config/craftBeerBogoValidation";
import { FaTrashRestore } from "react-icons/fa";
import { BsImageAlt } from "react-icons/bs";
import { ToastContainer, toast } from "react-toastify";
import {
  processOffers,
  updateOffersBasedOnDigitalCoupon,
  isValidPriceEAOffers,
  checkMinQtyDollarF,
  validatePrice,
  extractWPurchaseFields,
  approveOfferRestrictions,
  approveOfferValidations,
  normalizeWPurchaseText,
  checkDupeOfferEntry,
  maxIdenticalOfferEntries
} from "utils/offers";
import { MAX_IDENTICAL_SPLIT_ENTRIES } from "utils/products";
import { isCouponAutoCheckExcluded, computeCouponFlags } from "utils";
import { Modal, Button as AntBtn,  Popover, Input } from "antd";

export const OfferPage = () => {
  const params = useParams();
  const blockRef = useRef();
  const offerBuilderRef = useRef(null);
  const incentiveBuilderRef = useRef(null);
  const focusableSelector = useRef(
    [
      "input:not([type='hidden']):not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      "button:not([disabled])",
      "[tabindex]:not([tabindex='-1']):not([disabled])"
    ].join(",")
  );
  const {
    currentCircularId,
    currentPageId,
    currentAdBlockId,
    setCurrentCircularId,
    setCurrentPageId,
    setCurrentAdBlockId,
    setCurrentPage,
    setPreviousTime,
    postPageEvents,
    activeField,
    setActiveField,
    setFieldNames,
    moveNextField,
    updateActiveInfo,
    currentInfo,
    setCurrentInfo,
    setSessionId,
    activeFieldValue,
    updateInfo,
    setMetaData,
    setMetaDataFromPayload,
    isManualEntry,
    setIsManualEntry,
    movePreviousField,
    getMetaData,
    isSubmitting,
    setIsSubmitting,
    updateInfos,
    updateOfferText,
    setCurrentCircularDate,
    setCurrentCircularStartDate,
    updateLimitedTimeDates,
    updateLoyaltyShowMathFlags,
    metaData,
    setLiveCounterData,
    activeRetailer,
    setActiveRetailer
  } = useMainContext();

  //Loading States
  const [isLoading, setIsLoading] = useState(true);
  const [suggestionsLoading, setSuggestionsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(true);

  //For the skeleton partial
  const [imageHeight, setImageHeight] = useState(false);
  const [imageWidth, setImageWidth] = useState(false);

  // Page Data
  const [pageWidth, setPageWidth] = useState(1);
  const [pageHeight, setPageHeight] = useState(1);
  const [isLinerDisabled, setIsLinerDisabled] = useState(false);

  //Adblock Flags
  const [isApproved, setIsApproved] = useState(false);
  const [isRejected, setIsRejected] = useState(false);
  const [isSkipped, setIsSkipped] = useState(false);
  const [isDoNotEnter, setIsDoNotEnter] = useState(false);
  const [split, setSplit] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true)
  const [isSubmitChildDisabled, setIsSubmitChildDisabled] = useState(true)
  const [isOfferAndIncentiveEmpty, setIsOfferAndIncentiveEmpty] = useState(true)
  const [isImported, setIsImported] = useState(false)
  const [adblockInfo, setAdblockInfo] = useState(null);
  const [fsiRetailerIds, setFsiRetailerIds] = useState("");

  //Base List Data
  const [pageData, setPageData] = useState([]);
  const [adblockData, setAdblockData] = useState([]);
  const [offerTypeData, setOfferTypeData] = useState([]);
  const [circularName, setCircularName] = useState("");
  const [circularType, setCircularType] = useState("");
  const [parentRetailerName, setParentRetailerName] = useState("");
  const [groupsData, setGroupsData] = useState(null);
  const [sectionsData, setSectionsData] = useState(null);
  const [productData, setProductData] = useState([])
  const [sizeData, setSizeData] = useState([]);

  //Currently Viewed Information
  const [currentAdblockData, setCurrentAdblockData] = useState({});
  const [pageType, setpageType] = useState("");
  const [isDeepLinking, setIsDeepLinking] = useState(false);
  const [pageImg, setPageImg] = useState("");
  const [adblockFilename, setAdblockFilename] = useState("");

  //Offer list from adblock
  const [offerData, setOfferData] = useState([]);
  const currentOfferIndex = useInput(0);
  const [allOffersValid, setAllOffersValid] = useState(false);
  const [offerSuggestionData, setOfferSuggestionData] = useState(
    OFFER_INIT_SUGGESTIONS
  );
  const [existingSuggestionCount, setExistingSuggestionCount] = useState(0);
  const [existingSuggestionID, setexistingSuggestionID] = useState(null);

  //Incentives list from adblock
  const [incentiveData, setIncentiveData] = useState([]);
  const [incentiveSuggestionData, setIncentiveSuggestionData] = useState(
    INCENTIVE_INIT_SUGGESTION
  );

  //Adblock data
  const events = useInput([]);
  const [adblockCoords, setAdblockCoords] = useState({
    coords_x1: 0,
    coords_x2: 0,
    coords_y1: 0,
    coords_y2: 0,
  });
  const [sectionCoords, setSectionCoords] = useState({
    coords_x1: 0,
    coords_x2: 0,
    coords_y1: 0,
    coords_y2: 0,
  });
  const [startTime, setStartTime] = useState('');
  const [reviewNote, setReviewNote] = useState('');

  //Form Flow
  const [activeOfferInfoText, setActiveOfferInfoText] = useState("");

  //Suggestions
  const [currentSuggestions, setCurrentSuggestions] = useState([]);

  //Modals and user information
  const endQueueModal = useModal();
  const deleteOfferModal = useModal();
  const imageMatchingModal = useModal();
  const { userInfo } = useAuthContext();

  // For Training Circulars the Similar Block popup is gated by the Cloning
  // (check_dupe) setting; all other circular types open the popup as before.
  const openImageMatchingModalIfAllowed = async () => {
    if (circularType === "Training Circular") {
      const res = await getCloningApi({ circ_type: "Training Circular" });
      if (!(res.success && res.results && res.results.check_dupe)) {
        return;
      }
    }
    imageMatchingModal.openModal();
  };
  const [deletingOffer, setDeletingOffer] = useState({});
  const [currentItemType, setCurrentItemType] = useState("offer");
  const [useDefaultSaveOfferText, setUseDefaultSaveOfferText] = useState(true);
  const [firstDefaultSaveOfferText, setFirstDefaultSaveOfferText] = useState('');
  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState('');
  const [showNetUnitPriceModal, setShowNetUnitPriceModal] = useState(false);
  const [netUnitPriceValue, setNetUnitPriceValue] = useState({});
  const [priceWarningModelOpen, setPriceWarningModelOpen] = useState(false);
  const [priceWarningMessage, setPriceWarningMessage] = useState('');
  const [largeSaveOfferModalOpen, setLargeSaveOfferModalOpen] = useState(false);
  const [largeSaveOfferMessage, setLargeSaveOfferMessage] = useState('');
  const [showAdblockValidationModal, setShowAdblockValidationModal] = useState(false);
  const [adblockValidationMessage, setAdblockValidationMessage] = useState('');
  const [spaceWarningModalOpen, setSpaceWarningModalOpen] = useState(false);
  const [craftBeerBogoModalOpen, setCraftBeerBogoModalOpen] = useState(false);
  const [spaceWarningMessage, setSpaceWarningMessage] = useState('');

  // Flag of Current Page's digital_coupon_f
  const [digitalCouponApplied, setDigitalCouponApplied] = useState(false);
  const pageDataRef = useRef(pageData);
  const digitalCouponAppliedRef = useRef(digitalCouponApplied);

  // Whether the Coupon meta checkbox is disabled (no coupon signal present)
  const [couponDisabled, setCouponDisabled] = useState(true);

  /*
  ///////////////////////////////////////
  ////// Start View Methods ////////////
  /////////////////////////////////////
  */

  const init = async () => {
    setStartTime(new Date().toISOString().replace(',',''));
    setCurrentPage("LR - Offer");
    setPreviousTime(new Date());
    setIsLoading(true);
    setSessionId(String(new Date()));
    setOfferData([]);
    setProductData([]);
    setIncentiveData([]);
    setImageHeight(blockRef.current.offsetHeight);
    setImageWidth(blockRef.current.offsetWidth);
    setMetaData(INIT_OFFER_METADATA);

    const data = await getOfferTypesApi();
    setOfferTypeData(
      data.payload.map((item) => ({
        ...item,
        id: item.name,
        title: item.name,
      }))
    );
    setOfferSuggestionData({
      ...offerSuggestionData,
      offer_type: data.payload
        .sort((a, b) => a.ext_id - b.ext_id)
        .slice(0, 9)
        .map((item) => {
          return {
            title: item.name,
            value: item.name,
          };
        }),
    });

    const res = await getProductSizesApi();
    setSizeData(res.payload.map((item) => ({ id: item.ext_id, title: item.size_c })));
    
    setIsLoading(false);
  };

  const initInfo = () => {
    setActiveField("");
    setMetaData(INIT_OFFER_METADATA);
  };

  const handleSaveOffers = (offers) => {
    let updated = false;
    const newOffers = offers.map((offer) => {
      if (offer.offer_type?.toLowerCase() === 'save' && !offer.offer_text.includes("save ")) {
        updated = true;
        return { ...offer, offer_text: "save " + offer.offer_text };
      }
      return offer;
    });
    if (updated) {
      setOfferData(newOffers);
    }
  }

  /*
  ///////////////////////////////////////
  ////// Watchers /////////////////////
  /////////////////////////////////////
  */

  useEffect(() => {
    init();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const normalizedOfferText = normalizeWPurchaseText(currentInfo?.offer_text);
    const normalizedIncentiveText = normalizeWPurchaseText(
      currentInfo?.incentive_text
    );

    if (
      normalizedOfferText !== currentInfo?.offer_text ||
      normalizedIncentiveText !== currentInfo?.incentive_text
    ) {
      setCurrentInfo({
        ...currentInfo,
        ...(normalizedOfferText !== currentInfo?.offer_text
          ? { offer_text: normalizedOfferText }
          : {}),
        ...(normalizedIncentiveText !== currentInfo?.incentive_text
          ? { incentive_text: normalizedIncentiveText }
          : {}),
      });
    }
  }, [currentInfo?.offer_text, currentInfo?.incentive_text]);

  useEffect(() => {
    if (
      params?.circular !== "0" &&
      params?.page !== "0" &&
      params?.adblock !== "0"
    ) {
      setCurrentCircularId(params?.circular);
      setCurrentPageId(params?.page);
      setCurrentAdBlockId(params?.adblock);
      setIsDeepLinking(true);
    } else if (
      params?.circular !== "0" &&
      params?.page === "0" &&
      params?.adblock === "0"
    ) {
      setCurrentCircularId(params?.circular);
      setCurrentPageId("");
      setCurrentAdBlockId("");
    } else if (
      params?.circular !== "0" &&
      params?.page !== "0" &&
      params?.adblock === "0"
    ) {
      setCurrentCircularId(params?.circular);
      setCurrentPageId(params?.page);
      setCurrentAdBlockId("");
    }

    return () => {};
  }, [params?.circular, params?.page, params?.adblock]);

  useEffect(() => {
    if (currentAdBlockId) {
      setOfferData([]);
      setProductData([]);
      setIncentiveData([]);
      setCurrentInfo({});
      currentOfferIndex.setValue(0);
      fetchAdBlock(currentAdBlockId, true);
    }
    else {
      //unset all data
      setAdblockData([]);
      setCurrentAdblockData([]);
      setFsiRetailerIds("");
      setAdblockCoords({
        coords_x1: 0,
        coords_x2: 0,
        coords_y1: 0,
        coords_y2: 0,
      })
    }

    return () => {};
  }, [currentAdBlockId]);

  useEffect(() => {
    let firstOffer = [];
    if (offerData){
      firstOffer = offerData?.filter(item => 
        item?.offer_type.toLowerCase() === 'price ea' || item?.offer_type.toLowerCase() === 'bogo'  ||
        item?.offer_type.toLowerCase() === '& up' || item?.offer_type.toLowerCase() === 'x for' ||
        item?.offer_type.toLowerCase() === 'w/purchase/$' || item?.offer_type.toLowerCase() === 'w/purchase/qty' ||
        item?.offer_type.toLowerCase() === 'w/purchase/qty/$')
    }
    setUseDefaultSaveOfferText(false ? firstOffer.length > 0 : true);
    if (firstOffer.length > 0) {
      setUseDefaultSaveOfferText(false);
      let maxVal = 0;
      if (offerData && !currentInfo?.offer_text) {
        let findPriceEa = offerData.find(item => item.offer_type.toLowerCase() === "price ea");
        let findOffers = '';
        if (findPriceEa) {
          findPriceEa = findPriceEa.offer_text;
          let val = findPriceEa.split("-")
          // eslint-disable-next-line
          let numbers = val.map(item => item.replace(/[^\d\.]*/g, ''));
          maxVal = Math.max(...numbers)
        } else {
          findOffers = offerData.filter(item => item.offer_type.toLowerCase() !== "save")[0];
          if (findOffers) {
            if (findOffers.offer_type.toLowerCase() === 'bogo') {

            } else if (findOffers.offer_type.toLowerCase() === '& up') {
              maxVal = findOffers.offer_text.substring(1).split(' ')[0];
            } else if (findOffers.offer_type.toLowerCase() === 'x for') {
              maxVal = findOffers.offer_text.split('$')[1];
            } else if (findOffers.offer_type.toLowerCase() === 'w/purchase/$') {
              const reg = /w\/purchase\/\$(\d+(?:\.\d+)?)(?:-(\d+(?:\.\d+)?))?/;
              const match = findOffers.offer_text.match(reg);
              if (match) {
                const first = match[1];
                const second = match[2];
                if (first) {
                  if (second) {
                    maxVal = Math.max(first, second);
                  } else {
                    maxVal = first;
                  }
                }
              }
            } else if (findOffers.offer_type.toLowerCase() === 'w/purchase/qty') {
              const reg = /w\/purchase\/(\d+(?:\.\d+)?)(?:-(\d+(?:\.\d+)?))?/;
              const match = findOffers.offer_text.match(reg);
              if (match) {
                const first = match[1];
                const second = match[2];
                if (first) {
                  if (second) {
                    maxVal = Math.max(first, second);
                  } else {
                    maxVal = first;
                  }
                }
              }
            } else if (findOffers.offer_type.toLowerCase() === 'w/purchase/qty/$') {
              maxVal = findOffers.offer_text.split('$')[1];
            }
          }
        }
      }
      if (maxVal) {
        setFirstDefaultSaveOfferText(maxVal);
      }
    } else {
      setUseDefaultSaveOfferText(true);
    }
    return () => {};
  }, [offerData])

  useEffect(() => {
    if (currentCircularId) {
      fetchCircular();
    }
    return () => {};
  }, [currentCircularId]);

  useEffect(() => {
    if (
      isManualEntry &&
      activeField !== "" &&
      activeField.indexOf("_f") === -1 &&
      activeField !== "offer_type"
    ) {
      //Setting the timeout prevents the keypress from populating an input
      setTimeout(() => {
        if (document.getElementById(activeField))
          document.getElementById(activeField).focus();
      });
    }
    return () => {};
  }, [isManualEntry]);

  useEffect(() => {
    setAllOffersValid(
      isValidPriceEAOffers(offerData, isLinerDisabled, split) &&
      incentiveData.every(function (e) {
        return e?.isValid;
      })
    );

    // check every 'Store Savings' Adblock incentive, loyalty_f must be true.
    incentiveData.forEach((incentive) => {
      if (incentive?.incentive_attach_to === 'Adblock' && incentive?.incentive_type === 'Store Savings' && getMetaData().loyalty_f !== true) {
        setMetaData(mt => mt.map((item) => (item.key === 'loyalty_f' ? { ...item, value: true } : item)));
      }
    });
    return () => { };
  }, [offerData, incentiveData]);

  // Auto-manage the Coupon box (PEP-6516): it is disabled + cleared unless a
  // coupon signal exists (offer w/Coupon, Adblock coupon incentive, or coupon
  // page / digital coupon), in which case it is enabled and auto-checked.
  useEffect(() => {
    const offersForCheck = [
      ...offerData,
      ...(currentInfo?.offer_type ? [currentInfo] : []),
    ];
    const incentivesForCheck = [
      ...incentiveData,
      ...(currentInfo?.incentive_type ? [currentInfo] : []),
    ];
    const couponContext =
      (pageType === "Coupon Page" && !isCouponAutoCheckExcluded(activeRetailer?.retailer_name)) ||
      digitalCouponApplied;

    // couponDisabled is independent of the current coupon_f value, so compute it
    // outside the state updater (updaters must stay side-effect free).
    const { couponDisabled } = computeCouponFlags({
      offers: offersForCheck,
      incentives: incentivesForCheck,
      couponContext,
    });
    setCouponDisabled(couponDisabled);

    setMetaData((mt) => {
      const couponItem = mt.find((item) => item.key === "coupon_f");
      if (!couponItem) return mt;

      const { coupon_f, coupon_amnt } = computeCouponFlags({
        offers: offersForCheck,
        incentives: incentivesForCheck,
        couponF: couponItem.value,
        couponContext,
      });

      const nextCouponAmnt = coupon_f ? coupon_amnt : null;
      const isSame = (a, b) => {
        const normalize = (v) => (v === undefined || v === null || v === "" ? null : `${v}`);
        return normalize(a) === normalize(b);
      };
      if (couponItem.value === coupon_f && isSame(couponItem.coupon_amnt, nextCouponAmnt)) {
        return mt; // nothing changed – avoid a needless re-render
      }
      return mt.map((item) =>
        item.key === "coupon_f"
          ? { ...item, value: coupon_f, coupon_amnt: nextCouponAmnt }
          : item
      );
    });
    return () => {};
  }, [offerData, incentiveData, currentInfo, pageType, activeRetailer, digitalCouponApplied]);

  useEffect(() => {
    // Checking if Brand Equity is selected
    const isBrandEquitySelected = metaData.length > 1 && metaData[1].value;
    const disableApprove = isBrandEquitySelected ? (offerData.length || incentiveData.length && incentiveData.some(i => i.incentive_attach_to === 'Adblock')) : !offerData.length && !incentiveData.length;

    setIsSubmitDisabled(isBrandEquitySelected ? disableApprove : disableApprove || isSubmitChildDisabled)
    setIsOfferAndIncentiveEmpty(disableApprove);

    if (offerData.length === 0 && incentiveData.length === 0) {
      setCurrentItemType("");
      setActiveField("");
    }

    if (split && offerData.length !== productData.length) {
      setIsSubmitDisabled(true);
    }
    if (!isValidPriceEAOffers(offerData, isLinerDisabled, split)) {
      setIsSubmitDisabled(true);
    }

    return () => { };
  }, [split, offerData, incentiveData, metaData, isSubmitChildDisabled]);

  useEffect(() => {
    if (circularType === 'Training Circular'){
        setCurrentSuggestions([]);
    } else {
    if (activeField && currentItemType) {
      setCurrentSuggestions(
        currentItemType === "offer"
          ? offerSuggestionData[activeField]
          : incentiveSuggestionData[activeField] || []
      );
      if (
        currentInfo["offer_type"] === "w/purchase case" &&
        activeField === "offer_text"
      ) {
        setCurrentSuggestions([
          {
            value: "w/purchase/case",
            title: "w/purchase/case",
          },
          {
            value: "w/purchase/whole case",
            title: "w/purchase/whole case",
          },
          {
            value: "w/purchase/half case",
            title: "w/purchase/half case",
          },
        ]);
      } else if (
        currentInfo["offer_type"] === "w/purchase product" &&
        activeField === "offer_text"
      ) {
        let products = [];
        if (
          currentAdblockData?.products &&
          currentAdblockData?.products.length > 0
        ) {
          products =
            currentAdblockData?.products.map((p) => ({
              title: p.brand_nm,
              value: p.brand_nm,
            })) || [];
        } else if (
          currentAdblockData?.suggestions?.products &&
          currentAdblockData?.suggestions?.products.length > 0
        ) {
          products =
            currentAdblockData?.suggestions?.products.map((p) => ({
              title: p.brand_nm,
              value: p.brand_nm,
            })) || [];
        }
        setCurrentSuggestions(products);
      } else if (
        [
          "Clearance",
          "Extra Coupons",
          "Free Shipping",
          "Pharmacy Services",
          "Rollback",
          "Saturdate",
          "Sweepstakes",
          "Earn Free Item",
          "w/agreement",
        ].includes(currentInfo["incentive_type"]) &&
        activeField === "incentive_text"
      ) {
        setCurrentSuggestions(
          EXTRA_INCENTIVE_SUGGESTIONS[currentInfo["incentive_type"]]
        );
      }
      setActiveOfferInfoText(
        currentItemType === "offer"
          ? OFFER_SUGGESTION_TITLE[activeField]
          : INCENTIVE_SUGGESTION_TITLE[activeField]
      );
    }
  }

    return () => {};
  }, [activeField]);

  useEffect(() => {
    if (Object.keys(currentInfo).length > 0) {
      if (currentItemType === "offer") {
        let temp = [...offerData];
        temp[currentOfferIndex.value] = {
          ...currentInfo,
          isValid: validateOffer(currentInfo),
        };
      setOfferData(temp);
      handleSaveOffers(temp);
      } else if (currentItemType === "incentive") {
        // let temp = [...incentiveData];
        // setIncentiveData(
        //   temp.map((item) => {
        //     if (item.index === currentInfo.index)
        //       return {
        //         ...currentInfo,
        //         isValid: validateIncentive(currentInfo),
        //       };
        //     return { ...item };
        //   })
        // );

        let temp2 = [...incentiveData];
        temp2[currentInfo.index] = {
          ...currentInfo,
          isValid: validateIncentive(currentInfo),
        };
        console.log("incentive ===", currentInfo, temp2);
        setIncentiveData(temp2);
      }
    }
    return () => {};
  }, [currentInfo]);

  useEffect(()=> {
    if (productData){
      let linerExists = productData.find(item => item.liner_f === true);
      if (linerExists){
        setIsLinerDisabled(false);
      } else {
        setIsLinerDisabled(true);
      }
    }
  }, [productData])

  useEffect(() => {
    // Wait until the circular type is loaded so the training-circular check is reliable.
    if (!circularType) return;
    if (currentAdblockData.similar_adblock_uuid && !currentAdblockData.offers_approved && !currentAdblockData.is_dupe) {
      openImageMatchingModalIfAllowed()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAdblockData, circularType])

  const digitalCouponAppliedWatcher = async () => {
    if (pageDataRef.current) {
      const pageIndex = pageDataRef.current.findIndex((item) => item.uuid === currentPageId);
      if (pageIndex >= 0) {
        setDigitalCouponApplied(Boolean(pageDataRef.current[pageIndex]?.digital_coupon_f));
      }
    }
  }

  useEffect(() => {
    pageDataRef.current = pageData;
    digitalCouponAppliedWatcher();
    return () => {};
  }, [pageData])

  useEffect(() => {
    digitalCouponAppliedRef.current = digitalCouponApplied;
  }, [digitalCouponApplied])

  /*
  ///////////////////////////////////////
  ////// Fetch Main Data ////////////////
  /////////////////////////////////////
  */

  const fetchCircular = async () => {
    // const cirIncentiveData = await getCircularIncentives(currentCircularId);
    // setIncentiveSuggestionData({
    //   ...incentiveSuggestionData,
    //   incentive_text: cirIncentiveData.map((item) => ({
    //     title: item,
    //     value: item,
    //   })),
    // });
    const result = await getCircularById(currentCircularId);
    if (result.success) {
      //setCircularData(result.payload);
      setCircularName(
        result.payload.circ_subtype +
          "_" +
          result.payload.retailer.name +
          "_" +
          format(
            new Date(
              result.payload.circ_week_dt.replace(/-/g, "/").replace(/T.+/, "")
            ),
            "MM/dd/yyyy"
          ) +
          `_${result.payload.ext_id}` +
          `_${result.payload.circ_version ? result.payload.circ_version : 0}`
      );
      setCircularType(result.payload.circ_type);
      setParentRetailerName(result.payload?.retailer?.parent_name || "");
      if (result.payload.circ_type === 'Training Circular'){
        setCurrentSuggestions([]);
      }
    } else {
      //TODO: set error message about no circular matching
    }
    if(result.payload.circ_week_dt && result.payload.start_dt)
    {
      setCurrentCircularDate(format(new Date(result.payload.circ_week_dt.replace(/-/g, '/').replace(/T.+/, '')), "MM-dd-yyyy"));
      setCurrentCircularStartDate(format(new Date(result.payload.start_dt.replace(/-/g, '/').replace(/T.+/, '')), "MM-dd-yyyy"));
    }
  };

  const onPageSelect = async (params, data = [], initAfter = true) => {
    setCurrentPageId(params);
    setPageData(data);
    const currentPage = data.find((page) => page.uuid === params);
    if (currentPage) {
      const pageType = PAGE_TYPES.find((page) => page.page_c === currentPage.page_loc);
      setpageType(pageType.page_nm);

      let filename = currentPage.filename;
      let width = currentPage.img_width;
      let height = currentPage.img_height;
      if(currentPage.is_doubletruck) {
        filename = currentPage.doubletruck_filename;
        width = currentPage.img_width * 2;
        height = currentPage.img_height * 2;
      }
      setDigitalCouponApplied(Boolean(currentPage?.digital_coupon_f))
      let img
      const cachedImage = await getCachedImage(filename);
      if (!cachedImage) {
        img = await getImage(filename);
        if (img.success)
          await setCachedImage(filename, img.payload)
      }
      setPageWidth(width);
      setPageHeight(height);
      setPageImg(cachedImage ? cachedImage : img.payload);
    }
    if (!isDeepLinking) {
      setCurrentAdBlockId("");
    }
  };

  const fetchAdBlock = async (  
    adblockId,
    showLoading = true
  ) => {
    setIsFetching(true && showLoading);
    setIsImported(false);
    setIsApproved(false);
    setIsRejected(false);
    setIsDoNotEnter(false);
    setIsSkipped(false);
    setIncentiveData([]);
    setGroupsData(null);
    setSectionsData(null);
    setCurrentAdblockData([]);
    setFsiRetailerIds("");
    setProductData([]);
    setMetaData(INIT_OFFER_METADATA);
    setExistingSuggestionCount(0);
    setPriceWarningMessage('');
    setLargeSaveOfferMessage('');
    const res = await getCurrentUserAPI();
    if (res.success) {
      setLiveCounterData(res.results);
    }
    const result = await getAdBlockById(currentAdBlockId);
    if (result.success) {
      let payload = result.payload;
      if (payload) {
        let updateOfferSggs4DigitalCoupon = false;
        setIsManualEntry(true);
        setCurrentAdblockData(payload);
        setActiveRetailer({retailer_name: payload?.retailer_name});
        setFsiRetailerIds(payload?.fsi_retailer_i || "");
        setIsDoNotEnter(payload?.do_not_enter_f);
        setIsSkipped(payload?.skipped);
        setIsRejected(payload?.rejected);
        setSplit(payload?.split > 0 ? true : false);
        setGroupsData(payload?.group);
        setSectionsData(payload?.section);
        setAdblockCoords({
          coords_x1: payload.coords_x1,
          coords_x2: payload.coords_x2,
          coords_y1: payload.coords_y1,
          coords_y2: payload.coords_y2,
        });
        if (payload.section) {
          setSectionCoords({
            coords_x1: payload.section.coords_x1,
            coords_x2: payload.section.coords_x2,
            coords_y1: payload.section.coords_y1,
            coords_y2: payload.section.coords_y2,
          });
        }
        else {
          setSectionCoords({ coords_x1: 0, coords_x2: 0, coords_y1: 0, coords_y2: 0 })
        }
        
        if (payload.products_approved && payload.event_nm) {
          events.setValue(payload.event_nm.split(","));
        } else if (payload.group?.event_text) {
          events.setValue(payload.group.event_text.split(','));
        } else {
          events.setValue([]);
        }

        let offersData = [];
        let incentivesData = [];
        setIsApproved(payload.offers_approved);
        setIsManualEntry(payload.offers_approved);

        //This means the adblock is approved

        let existingOfferSuggestion = {};
        if(payload.offers.length > 0) {
          offersData = payload.offers.map((item, index) => ({
            ...item,
            isValid: validateOffer(item),
            index,
          }));
        } else {
          const existingSuggestion = await getSimilarAdBlockOffers(currentAdBlockId);
          if (existingSuggestion.success) {
            existingOfferSuggestion = existingSuggestion.payload;
            setAdblockInfo(existingSuggestion.payload?.adblock_info);
            if (
              !payload?.offers_approved &&
              existingOfferSuggestion &&
              existingOfferSuggestion?.offers) {
              if (existingOfferSuggestion?.offers.length > 0) {
                const newIndex = offersData.length > 0 ? offersData[offersData.length - 1].index + 1 : 0;
                const newOffer = existingOfferSuggestion.offers.map((item, index) => {
                  let updatedItem = {
                    ...item,
                    index: newIndex + index,
                    existingOffer: true
                  }
                  const withPurchaseFields = extractWPurchaseFields(updatedItem);
                  return {
                    ...withPurchaseFields,
                    isValid: validateOffer(withPurchaseFields),
                  };
                });
                offersData = [...offersData, ...newOffer];
                setExistingSuggestionCount(offersData.length)
                setexistingSuggestionID(existingSuggestion.payload?.adblock_id)
              }
            }
          }
          if (offersData.length === 0 &&
            payload?.suggestions &&
            payload?.suggestions?.offers.length > 0 &&
            !payload?.offers_approved
          ) {
            offersData = payload.suggestions.offers.map((item, index) => ({
              ...item,
              offer_type: item.offer_type.toLowerCase() === 'price ea' ? 'Price ea' : item.offer_type,
              isValid: validateOffer(item),
              index,
            }));
            updateOfferSggs4DigitalCoupon = true;
          } else {
            initInfo();
          }
        }
        if(payload.group !== null && payload.group.offer_type && !payload.offers_approved) {
          let group_offers = payload.group.offer_text.split(",")
          group_offers.forEach(
            offer => {
              const newIndex = offersData.length > 0 ? offersData[offersData.length - 1].index + 1 : 0;
              const newOffer = {
                ...OFFER_INIT_INFO,
                index: newIndex,
                isValid: true,
              };
              let text = offer;
              let offer_text = extractTextBetweenFirstBalancedParenthesis(text);
              let offer_type = 'Group'; // Temporary for existing Offer Text
              if (offer_text) {
                let index = offer_text.indexOf(" - ")
                offer_type = offer_text.slice(0, index).trim();
                offer_text = offer_text.slice(index + 2).trim();
                let reg_price = text.match(/\(RPS:(.+?)\)/);
                reg_price = Array.isArray(reg_price) ? reg_price[1] : ''
                let reg_price2_d = text.match(/\(RPS2:(.+?)\)/);
                reg_price2_d = Array.isArray(reg_price2_d) ? reg_price2_d[1] : ''
                let limit = text.match(/\(Limit:(.+?)\)/);
                limit = Array.isArray(limit) ? limit[1] : ''
                const { min_qty, min_qty_dollar_f } = checkMinQtyDollarF(offer_text, offer_type);
                let must_buy_f = text.match(/\(MustBuy\)/) ? true : false;
                let mix_and_match_f = text.match(/\(MixAndMatch\)/) ? true : false;
                let include_in_net_cost_f = text.match(/\(NetCost\)/) ? true : false;
                let liner_f = text.match(/\(Liner\)/) ? true : false;
                newOffer.reg_price = reg_price;
                newOffer.reg_price2_d = reg_price2_d;
                newOffer.limit = limit;
                newOffer.min_qty_dollar_f = min_qty_dollar_f
                newOffer.min_qty = min_qty
                newOffer.must_buy_f = must_buy_f;
                newOffer.mix_and_match_f = mix_and_match_f;
                newOffer.include_in_net_cost_f = include_in_net_cost_f;
                newOffer.liner_f = liner_f;
              } else {
                offer_text = text;
              }
              newOffer.offer_text = offer_text;
              newOffer.offer_type = offer_type;
              offersData = [...offersData, newOffer];
            }
          )
        }

        if(payload.group !== null && payload.group.incentive_type && !payload.offers_approved) {
          let group_incentives = getIncentiveInfo(payload.group.incentive_text);
          group_incentives.forEach(
            incentives => {
              const newIndex = incentivesData.length > 0 ?
                incentivesData[incentivesData.length - 1].index + 1 : 0;
              const newIncentive = {
                incentive_type: incentives.incentive_type,
                incentive_text: incentives.incentive_text,
                index: newIndex,
                isValid: true,
                group: true,
                incentive_attach_to: 'Adblock',
                incentive_limit: incentives.limit,
                incentive_include_net_cost: incentives.net_cost,
                incentive_by_mail: incentives.by_mail,
                incentive_online_incentive: incentives.online_incentive,
                incentive_liner_f: incentives.incentive_liner_f
              };
              incentivesData = [...incentivesData, newIncentive];
            })
        }

        if (updateOfferSggs4DigitalCoupon && digitalCouponAppliedRef.current){
          offersData = updateOffersBasedOnDigitalCoupon(offersData)
        }
        await setOfferData(offersData);
        
        handleSaveOffers(offersData);  
        setProductData(payload.products);
        let liner_disabled = false
        if (payload.products){
          liner_disabled = !payload.products?.find(item => item.liner_f === true);
        }
        if ((payload.split && payload.products.length !== offersData.length)){
          setIsSubmitDisabled(true);
        }

        //First split the incentives
        let tempIncentives = [];
        if (payload?.incentive_text) {
          getIncentiveInfo(payload?.incentive_text).forEach(
            incentives => {
              const newIncentive = {
                incentive_type: incentives.incentive_type,
                incentive_text: incentives.incentive_text,
                index: incentivesData.length > 0 ? incentivesData[incentivesData.length - 1].index + 1 : 0,
                isValid: true,
                incentive_attach_to: 'Adblock',
                incentive_limit: incentives.limit,
                incentive_include_net_cost: incentives.net_cost,
                incentive_by_mail: incentives.by_mail,
                incentive_online_incentive: incentives.online_incentive,
                incentive_liner_f: incentives.incentive_liner_f
              };
              incentivesData = [...incentivesData, newIncentive];
            })
        }

        if (!payload?.offers_approved && payload.suggestions?.incentives) {
          let incentive_suggestions = payload.suggestions.incentives;
          incentive_suggestions.forEach(
            incentives => {
              const newIncentive = {
                incentive_type: incentives.incentive_type,
                incentive_text: incentives.incentive_text,
                index: incentivesData.length > 0 ? incentivesData[incentivesData.length - 1].index + 1 : 0,
                isValid: true,
                incentive_attach_to: 'Adblock',
                incentive_limit: incentives.limit,
                incentive_include_net_cost: incentives.net_cost,
                incentive_by_mail: incentives.by_mail,
                incentive_online_incentive: incentives.online_incentive,
                incentive_liner_f: incentives.incentive_liner_f
              };
              incentivesData = [...incentivesData, newIncentive];
            })
        }

        // Remove this to use Page/Circular Data to fetch incentive 
        if (
          !payload?.offers_approved &&
          existingOfferSuggestion &&
          existingOfferSuggestion?.incentives) {
          if (existingOfferSuggestion?.incentives.length > 0) {
            const existingIncent = existingOfferSuggestion?.incentives.toString()
            if (existingIncent !== "") {
              getIncentiveInfo(existingIncent).forEach(
                incentives => {
                  const newIncentive = {
                    incentive_type: incentives.incentive_type,
                    incentive_text: incentives.incentive_text,
                    index: incentivesData.length > 0 ? incentivesData[incentivesData.length - 1].index + 1 : 0,
                    isValid: true,
                    incentive_attach_to: 'Adblock',
                    incentive_limit: incentives.limit,
                    incentive_include_net_cost: incentives.net_cost,
                    incentive_by_mail: incentives.by_mail,
                    incentive_online_incentive: incentives.online_incentive,
                    incentive_liner_f: incentives.incentive_liner_f,
                    existingIncentive: true,
                  };
                  incentivesData = [...incentivesData, newIncentive];
                })
            }
          }
        }
        const pageIncentive = await getPageIncentive(currentPageId);
        console.log(pageIncentive)
        const pageIncentiveText = pageIncentive?.incentive;
        if (pageIncentiveText) {
          getIncentiveInfo(pageIncentiveText).forEach(
            incentives => {
              const newIncentive = {
                incentive_type: incentives.incentive_type,
                incentive_text: incentives.incentive_text,
                index: incentivesData.length > 0 ? incentivesData[incentivesData.length - 1].index + 1 : 0,
                isValid: true,
                incentive_attach_to: 'Page',
                incentive_limit: incentives.limit,
                incentive_include_net_cost: incentives.net_cost,
                incentive_by_mail: incentives.by_mail,
                incentive_online_incentive: incentives.online_incentive,
                incentive_liner_f: incentives.incentive_liner_f
              };
              incentivesData = [...incentivesData, newIncentive];
            })
        }
        const circularIncentive = await getCircularIncentive(currentCircularId);
        const circularIncentiveText = circularIncentive?.incentive;
        console.log("circ", circularIncentiveText, currentCircularId)
        if (circularIncentiveText) {
          getIncentiveInfo(circularIncentiveText).forEach(
            incentives => {
              const newIncentive = {
                incentive_type: incentives.incentive_type,
                incentive_text: incentives.incentive_text,
                index: incentivesData.length > 0 ? incentivesData[incentivesData.length - 1].index + 1 : 0,
                isValid: true,
                incentive_attach_to: 'Circular',
                incentive_limit: incentives.limit,
                incentive_include_net_cost: incentives.net_cost,
                incentive_by_mail: incentives.by_mail,
                incentive_online_incentive: incentives.online_incentive,
                incentive_liner_f: incentives.incentive_liner_f
              };
              incentivesData = [...incentivesData, newIncentive];
            })
        }

        const mergedIncentives = [...incentivesData, ...tempIncentives];
        setIncentiveData(mergedIncentives);

        if (offersData.length > 0) {
          setCurrentInfo(offersData[0]);
          currentOfferIndex.setValue(0);
          setCurrentItemType("offer");
          setFieldNames(liner_disabled ? OFFER_INFO_FIELDS.filter(offer => offer !== 'liner_f') : OFFER_INFO_FIELDS);
          setOfferSuggestionData({
            ...offerSuggestionData,
            offer_text: offersData.slice(0, 9).map((item, index) => {
              return {
                title: item.offer_text,
                value: item.offer_text,
              };
            }),
          });
        }

        // Enable Coupon Meta Check if Coupon Page (except excluded retailers, e.g. Target Stores)
        const metaDataFromPayload = {
          ...result.payload.adblock,
          coupon_f: true
        }
        setMetaDataFromPayload(!payload.offers_approved && !isCouponAutoCheckExcluded(payload?.retailer_name) && pageDataRef.current.find((item) => item.uuid === currentPageId)?.page_loc === "4" ? metaDataFromPayload : payload);

        if (payload.group !== null && !payload.offers_approved) {
          if (payload.group.limited_time) {
          const start = payload.group?.start;
          const end = payload.group?.end;
          updateLimitedTimeDates({
            limitedDateFrom: start,
            limitedDateTo: end,
          }, true)
          }
          updateLoyaltyShowMathFlags(payload.group?.loyalty_f, payload.group?.show_math_f, payload.group?.online_only_f, payload.group?.sponsored_f)
        }
        setAdblockFilename(payload.filename);
        setTimeout(() =>{
          setMetaDataFromPayload(!payload.offers_approved && !isCouponAutoCheckExcluded(payload?.retailer_name) && pageDataRef.current.find((item) => item.uuid === currentPageId)?.page_loc === "4" ? metaDataFromPayload : payload);
        }, 200)
        postPageEvents("ready", "");
        navigate(`/offer/${currentCircularId}/${currentPageId}/${adblockId}`);
      }
    }
    setIsFetching(false && showLoading);
  };

  const handleAdblockSelect = (params, data = []) => {
    setIsDeepLinking(false);
    if (!params && data.length === 0) {
      setCurrentAdBlockId("");
      setAdblockData([]);
      setCurrentSuggestions([]);
      setOfferData([]);
      setProductData([]);
      initInfo();
      setIsFetching(false);
      navigate(`/offer/${currentCircularId}/${currentPageId}/0`);
    } else {
      setCurrentAdBlockId(params);
      // setAdblockData(data);
      // fetchAdBlock(params, data);
    }
    setStartTime(new Date().toISOString().replace(',',''));
  };

  const onAdblockDataLoad = (params = []) => {
    setAdblockData(params);
  };

  const refetchAdblocks = async () => {
    const result = await getPageCrops(currentPageId);
    const newData = result?.payload?.adblocks;
    setAdblockData(newData);
  };
  const navigateNext = () => {
    //Turn manual entry off when going to next set
    setIsManualEntry(false);
    setStartTime(new Date().toISOString().replace(',',''));

    const pageIndex = pageData.findIndex((item) => item.uuid === currentPageId);
    const adblockIndex = adblockData.findIndex(
      (item) => item.uuid === currentAdBlockId
    );
    if (adblockIndex < adblockData.length - 1) {
      setCurrentAdBlockId(adblockData[adblockIndex + 1].uuid);
    } else if (
      adblockIndex === adblockData.length - 1 &&
      pageIndex < pageData.length - 1
    ) {
      setCurrentPageId(pageData[pageIndex + 1].uuid);
      setCurrentAdBlockId("");
    } else if (
      adblockIndex === adblockData.length - 1 &&
      pageIndex === pageData.length - 1
    ) {
      // AD-4417: this branch leaves currentAdBlockId untouched, so the effect
      // watching it never refires and currentAdBlockData keeps its pre-action
      // flags. Refetch so the is_dupe guards on Approve see the server state
      // after a Complete Match / Duplicate / Move to Review Queue.
      fetchAdBlock(currentAdBlockId, true);
      endQueueModal.openModal();
    }
  };
  
  const navigateNextUnapproved = () => {
    setIsManualEntry(false);
    setStartTime(new Date().toISOString().replace(',',''));
    const pageIndex = pageData.findIndex((item) => item.uuid === currentPageId);
    const adblockIndex = adblockData.findIndex((item) => item.uuid === currentAdBlockId);

    var nextBlock = null;
    if (adblockIndex < adblockData.length - 1) {
      nextBlock = adblockIndex + 1;

      while(nextBlock < adblockData.length - 1 && adblockData[nextBlock].offers_approved){
        nextBlock = nextBlock + 1;
      }

      if(!adblockData[nextBlock].offers_approved){
        setCurrentAdBlockId(adblockData[nextBlock].uuid);
      }
      else{
        nextBlock = null;
      }
    }

    if(!nextBlock){ 
      if (
        adblockIndex === adblockData.length - 1 &&
        pageIndex < pageData.length - 1
      ) {
        setCurrentPageId(pageData[pageIndex + 1].uuid);
        setCurrentAdBlockId("");
      } else if (
        adblockIndex === adblockData.length - 1 &&
        pageIndex === pageData.length - 1
      ) {
        endQueueModal.openModal();
      }
    }
  };

  /*
  ///////////////////////////////////////
  ////// Set Adblock Flags /////////////
  /////////////////////////////////////
  */

  const handleReject = async (reject_message, remove_children) => {
    setIsSubmitting(true);
    let result = await rejectAdblock(currentAdBlockId, "offer", reject_message, remove_children);
    if (result.success) {
      // Update adblocks
      result = await getPageCrops(currentPageId);
      setAdblockData(result?.payload?.adblocks);

      navigateNextUnapproved();
    } else {
      //TODO: Show error message
    }
    setIsSubmitting(false);
  };

  const handleResetAdblock = async () => {
    setIsSubmitting(true);
    const result = await resetAdblock(currentAdBlockId);
    if (result.success) {
      //reload page
      navigate(0);
    } else {
      setIsSubmitting(false);
    }
  }

  const calculateNetCost = async (offers) => {
    // Calculate Net Unit Price
    let get_offer_values = await getOfferValuesApi(offers);
    if (get_offer_values.success) {
      let offerValues = get_offer_values.payload.map((item, index) => {
        let offer = offers.find(offer => offer.offer_text === item.offer_text);
        let min_qty = offer.min_qty;
        let min_qty_dollar_f = offer.min_qty_dollar_f;
        if (min_qty === null) {
          min_qty = 0;
        }
        if (min_qty_dollar_f === null) {
          min_qty_dollar_f = false;
        }
        return {
          ...item,
          min_qty: min_qty,
          min_qty_dollar_f: min_qty_dollar_f,
          liner_f: offer.liner_f,
        };
      });

      let calculatedValues = {};

      // Calculate net unit price for liner_f offers separately
      let linerOffers = offerValues.filter(offer => offer.liner_f === true);
      let nonLinerOffers = offerValues.filter(offer => offer.liner_f === false);
      
      // Process non-liner offers first if nonLinerOffers length is greater than 1
      if (nonLinerOffers.length > 1) {
        const nonLinerVal = processOffers(nonLinerOffers);
        if (nonLinerVal !== undefined && nonLinerVal !== null) {
          calculatedValues.nonLiner = nonLinerVal;
        }
      }

      // Process liner offers if they exist
      if (linerOffers.length > 1) {
        const linerVal = processOffers(linerOffers);
        if (linerVal !== undefined && linerVal !== null) {
          calculatedValues.liner = linerVal;
        }
      }

      // Only show modal and return false if we have valid calculated values
      if (Object.keys(calculatedValues).length > 0) {
        setNetUnitPriceValue(calculatedValues);
        setShowNetUnitPriceModal(true);
        setIsSubmitting(false);
        return false;
      }
    }
    return true;
  }

  const handleApprove = async ({ force = false, skipValidation = false, skipCraftBeerCheck = false } = {}) => {
    //Check for space after slash in offers and incentives
    const errorMessage = checkSpaceAfterSlash(offerData, incentiveData);
    if (errorMessage) {
      setSpaceWarningMessage(errorMessage);
      setSpaceWarningModalOpen(true);
      return;
    }

    // AD-4177: remind entry people about unbranded Craft Beer BOGOs at certain retailers
    if (!skipCraftBeerCheck && isCraftBeerBogoViolation({
      products: productData,
      offers: offerData,
      retailerName: activeRetailer?.retailer_name,
    })) {
      setCraftBeerBogoModalOpen(true);
      return;
    }

    if (currentAdblockData?.is_dupe) {
      toast.error("This adblock has been marked as duplicate and cannot be approved. Reset the block to modify it", {
        position: "bottom-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        progress: undefined,
        theme: "dark",
      });
      return;
    }
    setIsSubmitting(true);
    
    const int_keys = [
      "reg_price",
      "reg_price2_d",
      "limit",
      "coupon_amount",
      "rebate_amount",
      "min_qty",
    ];
    
    // Check if offerData has isValid false or empty values
    let inValidOffer = offerData.some((offer) => !offer.isValid);
    if (inValidOffer) {
      setIsSubmitting(false);
      setIsSubmitDisabled(true);
      toast.error("Invalid Offer Entered", {
        position: "bottom-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        progress: undefined,
        theme: "dark",
      });
      return;
    }
    let offers = offerData.map((offer) => omit(offer, [
      // "index", 
      "isValid"]));
    if (productData.length < 1) {
      setIsSubmitDisabled(true);
      setIsSubmitting(false);
      return
    }
    if ((offers.length < 1 && incentiveData.length < 1 && !metaData[1].value)) {
      setIsSubmitDisabled(true);
      setIsSubmitting(false);
      return
    }
    let index = 0;
    offers.forEach((offer) => {
      Object.entries(offer).forEach(([key, value]) => {
        if (value === "" && int_keys.indexOf(key) !== -1) {
          offer[key] = null;
        }
        if (key === 'min_qty' || key === 'min_qty_dollar_f') {
          const { min_qty, min_qty_dollar_f } = checkMinQtyDollarF(offer.offer_text, offer.offer_type);
          offer['min_qty'] = min_qty;
          offer['min_qty_dollar_f'] = min_qty_dollar_f;
        }
      });

      offer['order_num'] = index;
      index++;

    });

    offers = offers.map(offer => omit(offer, 'index'));

    // Non-split blocks must not contain identical offer entries (the backend
    // would silently drop them); warn the operator instead of submitting.
    if (!split && checkDupeOfferEntry(offers)) {
      setIsSubmitting(false);
      toast.error("Duplicate offer entries detected. This is not a split adblock, please remove the duplicate offers and reapprove.", {
        position: "bottom-right", autoClose: 8000, hideProgressBar: false, closeOnClick: true,
        pauseOnHover: true, progress: undefined, theme: "dark",
      });
      return;
    }

    // Split blocks legitimately allow duplicate entries, but a flood of
    // identical rows is accidental duplication (e.g. a held clone hotkey).
    if (split && maxIdenticalOfferEntries(offers) > MAX_IDENTICAL_SPLIT_ENTRIES) {
      setIsSubmitting(false);
      toast.error(`More than ${MAX_IDENTICAL_SPLIT_ENTRIES} identical offer entries detected. This looks like accidental duplication, please remove the extra rows and reapprove.`, {
        position: "bottom-right", autoClose: 8000, hideProgressBar: false, closeOnClick: true,
        pauseOnHover: true, progress: undefined, theme: "dark",
      });
      return;
    }

    if (!force && offers.length > 1 && !split) {
      const cal = await calculateNetCost(offers.filter(offer => offer.include_in_net_cost_f === true));
      if (!cal) {
        setIsSubmitting(false);
        return;
      }
    }

    for (const value of offers) {
      try {
        await offerValidationSchema.validate(value, { abortEarly: false });
      } catch (err) {
        console.error('Validation failed');
        if (err.name === 'ValidationError') {
          err.inner.forEach((error) => {
            setIsSubmitting(false);
            toast.error(`${error.message}`, {
              position: "bottom-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              progress: undefined,
              theme: "dark",
            });
          });
        }
        return;
      }
    }

    //standarize offer text
    offers.forEach((offer) => {
      let offerText = standardizeText(offer.offer_text);
      offer.offer_text = offerText;
    });
    
    const adblock = {
      ...getMetaData(),
      fsi_retailer_i: fsiRetailerIds,
      split: split ? 1 : 0,
      event_nm: events.value.join(),
      incentive_text: incentiveData
        .filter(
          (a) => validateIncentive(a) && a?.incentive_attach_to === "Adblock"
        )
        .map((a) => `${a?.incentive_liner_f ? `(L)`
          :''}${a?.incentive_type ? `(${a?.incentive_type}) `
          : ''}${a.incentive_text ? standardizeText(a.incentive_text)
            : ''} (${a?.incentive_limit ? `${a?.incentive_limit}`
              : ""}) (${a?.incentive_include_net_cost ? `Net Cost`
                : ''}) (${a?.incentive_by_mail ? `1`
                  : `0`}) (${a?.incentive_online_incentive ? `1`
                    : `0`})`)
        .join(","),
    }

    const endTime = new Date().toISOString().replace(',','')

    if (!isImported) {
      adblock.ltr_offer_started_at = startTime
      adblock.ltr_offer_finished_at = endTime
    } else {
      adblock.offer_import_started_at = startTime
      adblock.offer_import_finished_at = endTime
    }

    let existingSuggestionsEnteredCount = 0
    if (existingSuggestionCount > 0) {
      existingSuggestionsEnteredCount = offers.filter(offer => offer.existingOffer).length
    }

    let adblock_suggestion_data = [];

    if (existingSuggestionCount > 0) {
      let adblock_existing_suggestion_data = {
        adblock_uuid : currentAdBlockId,
        suggestion_type: 'existing_suggestions',
        suggestion_count: existingSuggestionCount,
        suggestion_accepted_count: existingSuggestionsEnteredCount,
        existing_suggestion_from: existingSuggestionID
      }
      adblock_suggestion_data.push(adblock_existing_suggestion_data)
    }

    if (!split) {
      const restrictions = approveOfferRestrictions({ offers: offers, linerNetCost: netUnitPriceValue.liner, nonLinerNetCost: netUnitPriceValue.nonLiner });
      if (restrictions.error === true) {
        setIsSubmitting(false);
        toast.error(restrictions.message, {
          position: "bottom-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          progress: undefined,
          theme: "dark",
        });
        return;
      }
    }

    const validations = approveOfferValidations({ offers: offers, incentives: incentiveData, adblock: adblock });

    if (validations.error === true && !skipValidation) {
      setIsSubmitting(false);
      setAdblockValidationMessage(validations.message);
      if (validations.canOverride) {
       setShowAdblockValidationModal(true);
      } else {
        toast.error(validations.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          progress: undefined,
          theme: "dark",
        });
       }
      return;
    }

    let data = {
      adblock: adblock,
      offers: offers,
      adblock_suggestion_tracking : adblock_suggestion_data
    };

    await saveCircularIncentives(
      currentCircularId,
      incentiveData.filter(
        (a) => validateIncentive(a) && a?.incentive_attach_to === "Circular"
      )
    );
    await savePageIncentives(
      currentPageId,
      incentiveData.filter(
        (a) => validateIncentive(a) && a?.incentive_attach_to === "Page"
      )
    );

    console.log('approve data', data);
    let result = await approveOffer(currentAdBlockId, data);
    if (result.success) {
      //Update adblocks
      const res = await getCurrentUserAPI();
      if (res.success) {
        setLiveCounterData(res.results);
      }
      result = await getPageCrops(currentPageId);
      setAdblockData(result?.payload?.adblocks);
      setIsApproved(true);
      navigateNextUnapproved();
    } else {
      if (result.error) {
        const errorMessage = result.error?.response?.data?.errors[0] || result.error?.message || "An error occurred while approving the offer";
        if (errorMessage && (
          errorMessage.includes('value greater than 50% which is not allowed as per sub-category policy') ||
          errorMessage.includes('liner offers entry has value greater than 50%') ||
          errorMessage.includes('non-liner offers entry has value greater than 50%')
        )) {
          setLargeSaveOfferMessage(errorMessage);
          setLargeSaveOfferModalOpen(true);
          setIsSubmitting(false);
          return;
        }
      }
    }
    setIsSubmitting(false);
  };

  const handleSkipAdblock = async () => {
    setIsSubmitting(true);
    let result = await skipAdblock(currentAdBlockId, {}, "offers");
    if (result.success) {
      // Update adblocks
      result = await getPageCrops(currentPageId);
      setAdblockData(result?.payload?.adblocks);
      navigateNextUnapproved();
    } else {
      //TODO: Show error message
    }
    setIsSubmitting(false);
  };

  const handleOpenModal = () => {
    setConfirmationMessage("Are you sure you want to mark this block as DNE?");
    setConfirmationModalOpen(true);
  };

  const handleCancelConfirmation = () => {
    setConfirmationModalOpen(false);
  };

  const handleContinue = async () => {
    setConfirmationModalOpen(false);
    await handleDoNotEnterAdblock();
  };

  const handleDoNotEnterAdblock = async () => {
    setIsSubmitting(true);
    let result = await doNotEnterAdblock(currentAdBlockId, {
      ltr_offer_started_at: startTime,
      ltr_offer_finished_at: new Date().toISOString().replace(',',''),
    }, "offers");
    if (result.success) {
      // Update adblocks
      result = await getPageCrops(currentPageId);
      setAdblockData(result?.payload?.adblocks);
      const res = await getCurrentUserAPI();
      if (res.success) {
        setLiveCounterData(res.results);
      }
      navigateNextUnapproved();
    } else {
      //TODO: Show error message
    }
    setIsSubmitting(false);
  };

  const handleAddItem = (type) => {
    switch (type) {
      case "offer":
        handleAddOffer();
        break;
      case "incentive":
        handleAddIncentive();
        break;

      default:
        break;
    }
    setCurrentItemType(type);
  };

  const handleSplit = (value) => {
    console.log('split', value);
    setSplit(value);
  }

  const handleSelectFsiRetailers = (values = []) => {
    const retailerIds = values
      .map((item) => item?.value)
      .filter(Boolean)
      .join(",");

    setFsiRetailerIds(retailerIds);
  }


  /*
  ///////////////////////////////////////
  ////// Offer Controls /////////////
  /////////////////////////////////////
  */

  const handleAddOffer = () => {
    const newIndex =
      offerData.length > 0 ? offerData[offerData.length - 1].index + 1 : 0;
    const newOffer = {
      ...OFFER_INIT_INFO,
      index: newIndex,
      isValid: false,
    };
    //We need to always have net cost and total purchase checked
    newOffer.include_in_net_cost_f = true;
    setOfferData([...offerData, newOffer]);
    currentOfferIndex.setValue(newIndex);
      setCurrentInfo(newOffer);
      setFieldNames(isLinerDisabled ? OFFER_INFO_FIELDS.filter(offer => offer !== 'liner_f') : OFFER_INFO_FIELDS);
    setCurrentItemType("offer");
    console.log("offer index", newIndex);
  };

  const handleRemoveOffer = (event, index) => {
    const curr = offerData.find((offer) => offer.index === index)
    if (curr?.uuid) {
      deleteOfferModal.openModal();
    }
    else {
      const idx = offerData.findIndex((offer) => offer.index === index);
      console.log("delete offer idx", idx);
      const newOffersData = offerData
        .filter((item) => item?.index !== index)
        .map((item, index) => ({
          ...item,
          isValid: validateOffer(item),
          index,
        }));

      setOfferData(newOffersData);

      if (currentItemType === "offer") {
        if (newOffersData.length === 0) {
          setCurrentInfo({});
          currentOfferIndex.setValue(0);
          if (incentiveData.length > 0) {
            setCurrentInfo(incentiveData[0]);
            setCurrentItemType("incentive");
          }
        } else {
          const newIdx = newOffersData.length > idx ? idx : idx - 1;
          currentOfferIndex.setValue(newOffersData[newIdx].index);
          console.log("current info 111 ===", newOffersData[newIdx]);
          setCurrentInfo(newOffersData[newIdx]);
        }
      }
    } 
    setDeletingOffer(offerData.find((offer) => offer.index === index));
  };

  const handleCloneOffer = (event, index) => {
    // event.stopPropagation();
    if (offerData.length > 0) {
      let temp = [...offerData];

      if (index == null || index == undefined) {
        index = temp.findIndex(
          (offer) => offer.index === currentOfferIndex.value
        );
      }
      setCurrentItemType("offer");
      const clonedOffer = { ...offerData[index] };
      const newIndex = offerData[offerData.length - 1].index + 1;
      setOfferData([
        ...offerData,
        { ...clonedOffer, index: newIndex, uuid: undefined },
      ]);
      setCurrentInfo({ ...clonedOffer, index: newIndex, uuid: undefined });
      currentOfferIndex.setValue(newIndex);
    }
  };

  const handleOfferSelect = (index) => {
    currentOfferIndex.setValue(index);
    setCurrentItemType("offer");
    setFieldNames(isLinerDisabled ? OFFER_INFO_FIELDS.filter(offer => offer !== 'liner_f') : OFFER_INFO_FIELDS);
    setActiveField(OFFER_INFO_FIELDS[0]);
    setCurrentInfo(offerData[index]);
  };
  ///////////////////////////////////////
  ////// Incentive Controls /////////////
  /////////////////////////////////////

  const handleAddIncentive = () => {
    const newIndex =
      incentiveData.length > 0
        ? incentiveData[incentiveData.length - 1].index + 1
        : 0;
    const newIncentive = {
      ...INCENTIVE_INIT_INFO,
      index: newIndex,
      isValid: false,
      isAddedIncentive:true
    };
    setIncentiveData([...incentiveData, newIncentive]);
    setCurrentItemType("incentive");
    setFieldNames(INCENTIVE_INFO_FIELDS);
    setCurrentInfo(newIncentive);
  };

  const handleRemoveIncentive = async (event, index) => {
    const idx = incentiveData.findIndex(
      (incentive) => incentive.index === index
    );
    const newIncentivesData = incentiveData
      .filter((item) => item?.index !== index)
      .map((item, index) => ({
        ...item,
        isValid: validateIncentive(item),
        index,
      }));


    let newCurrentInfo = {};
    if (currentItemType === "incentive") {
      if (newIncentivesData.length === 0) {
        newCurrentInfo = { index: 0 };
        setCurrentItemType("");
        if (offerData.length > 0) {
          console.log("offerData", offerData);
          setCurrentItemType("offer");
          currentOfferIndex.setValue(offerData[0].index);
          setCurrentInfo(offerData[0]);
        }
      } else {
        const newIdx =
          newIncentivesData.length === 1
            ? 0
            : newIncentivesData.length > idx
            ? idx
            : idx - 1;
        newCurrentInfo = newIncentivesData[newIdx];
        setCurrentInfo(newCurrentInfo);
      }
    }
    

    const curr = incentiveData.find((incentive) => incentive.index === index)
    if (isApproved && curr.isAddedIncentive == null && curr.isClonedIncentive == null) {
      const result = await unApproveOffer(currentAdBlockId);
      if (result.success) {
        setIsApproved(false);
      }
    }

    setIncentiveData(newIncentivesData);
  };

  const handleCloneIncentive = (event, index) => {
    event.stopPropagation();

    if (incentiveData.length > 0) {
      const newIndex = incentiveData[incentiveData.length - 1].index + 1;
      setCurrentItemType("incentive");
      setIncentiveData([
        ...incentiveData,
        { ...incentiveData[index], isClonedIncentive:true, index: newIndex, uuid: undefined },
      ]);
    }
  };

  const handleIncentiveSelect = (index) => {
    console.log("incentive select", index, { ...incentiveData[index] });
    setCurrentItemType("incentive");
    setFieldNames(INCENTIVE_INFO_FIELDS);
    setActiveField(INCENTIVE_INFO_FIELDS[0]);
    setCurrentInfo(incentiveData[index]);
  };


  /*
  ///////////////////////////////////////
  ////// Adblock Refresh ///////////////
  /////////////////////////////////////
  */

  const refreshAdblockSuggestions = async () => {
    postPageEvents("click", "Refresh Quick Selection");
    setSuggestionsLoading(true);
    const result = await updateAdblockSuggestions(currentAdBlockId);
    if (result.success) {
      let offers = [];
      setIsApproved(result.payload.offers_approved);

      //This means the adblock is approved
      if (result.payload.offers.length > 0) {
        offers = result.payload.offers.map((item, index) => ({
          ...item,
          isValid: validateOffer(item),
          index,
        }));
      } else if (result.payload.suggestions.offers.length > 0) {
        offers = result.payload.suggestions.offers.map((item, index) => ({
          ...item,
          isValid: validateOffer(item),
          index,
        }));
      }
      setOfferData(offers);
      if (offers.length > 0) {
        setCurrentInfo(offers[0]);
        currentOfferIndex.setValue(0);
        setCurrentItemType("offer");
        setFieldNames(isLinerDisabled ? OFFER_INFO_FIELDS.filter(offer => offer !== 'liner_f') : OFFER_INFO_FIELDS);
      }
    }
    setSuggestionsLoading(false);
  };

  const handleImport = (data) => {
    setIsImported(true);
    const { offers, incentive_nm } = data.payload;
    const offersData = offers.map((item, index) => {
      delete item.uuid;
      return {
      ...item,
      offer_type: item.offer_type.toLowerCase() === 'price ea' ? 'Price ea' :  item.offer_type,
      isValid: validateOffer(item),
      index,
    }});
    setOfferData(offersData);
    
    // Parse and set incentives if they exist
    if (incentive_nm && incentive_nm !== '') {
      let incentivesDataIM = []; 
      const parsedIncentives = getIncentiveInfo(incentive_nm);
          parsedIncentives.forEach(
            incentives => {
              const newIndex = incentiveData.length > 0 ?
                incentiveData[incentiveData.length - 1].index + 1 : 0;
              const newIncentive = {
                incentive_type: incentives.incentive_type,
                incentive_text: incentives.incentive_text,
                index: newIndex,
                isValid: true,
                incentive_attach_to: 'Adblock',
                incentive_limit: incentives.limit,
                incentive_include_net_cost: incentives.net_cost,
                incentive_by_mail: incentives.by_mail,
                incentive_online_incentive: incentives.online_incentive,
                incentive_liner_f: incentives.incentive_liner_f
              };
              incentivesDataIM = [...incentivesDataIM, newIncentive];
            })
      if(incentivesDataIM.length > 0) {
        setIncentiveData([...incentiveData, ...incentivesDataIM]);
      }
    }
  } 

  /*
  ///////////////////////////////////////
  ////// Form and Quickslection Changes ///////////////
  /////////////////////////////////////
  */

  const handleSuggestionClick = (value, event) => {
    if (value === "Manual") {
      setIsManualEntry(true);
    } else {
      if (activeField === "offer_type") {
        if (((value === 'Save' || value === 'save') && useDefaultSaveOfferText) || value !== 'Save') {
          setTimeout(() => {
            updateInfos({
              offer_text: INIT_OFFER_TEXT[value.toLowerCase()],
              offer_type: value,
            });
          }, 300);
        } else {
          updateInfos({
            offer_text: `save ${firstDefaultSaveOfferText}%`,
            offer_type: value,
          });
        }
      }
      else if (activeField === "incentive_type" && value === "Store Savings") {
        updateActiveInfo(value);
      }
       else {
        updateActiveInfo(value);
      }
      moveNextField();
    }
  };

  /*
  ///////////////////////////////////////////////
  ////// Incentive Info Change //////////////////
  ///////////////////////////////////////////////
  */

  /*
  ///////////////////////////////////////
  ////// Key Commands //////////////////
  /////////////////////////////////////
  */

  // Handle key press for quick selection
  useKeypress(["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"], (event) => {
    if (parseInt(event.key) <= currentSuggestions.length && !isManualEntry) {
      event.preventDefault();
      var value, title;

      //Any time the user clicks zero they are going to manual entry
      if (parseInt(event.key) === 0) {
        value = "Manual";
      } else {
        value = currentSuggestions[parseInt(event.key) - 1].value;
        title = currentSuggestions[parseInt(event.key) - 1].title;
      }

      handleSuggestionClick(value, title);
    }
  });

  //Disable manual entry by pressing escape
  useKeypress(["Escape"], (event) => {
    if (isManualEntry) {
      ////setInputFocused(false);
      setIsManualEntry(false);
    }
    if (document.activeElement) {
      document.activeElement.blur();
    }
  });

  //Remove Offers
  useKeypress(["-"], (event) => {
    // if (event.altKey) {
    //   handleRemoveOffer(event);
    // }
  });

  //Add Offers
  useKeypress(["+"], (event) => {
    // Ignore OS key-repeat: holding the key must not create a row per repeat.
    if (event.repeat) return;
    if (event.altKey) {
      handleAddOffer();
    }
  });

  //Clone Offers
  useKeypress(["o"], (event) => {
    // Ignore OS key-repeat: holding Alt+O must not clone a row per repeat.
    if (event.repeat) return;
    if (event.altKey) {
      handleCloneOffer();
    }
  });

  //Cycle through offers
  useKeypress(["["], (event) => {
    event.preventDefault();
    if (event.shiftKey) {
      //If we go backwards to the start, go back to top.
      if (currentOfferIndex.value === 0) {
        currentOfferIndex.setValue(offerData.length - 1);
      } else {
        currentOfferIndex.setValue(currentOfferIndex.value - 1);
      }
    } else {
      //If we go forward to the end, go back to start.
      if (currentOfferIndex.value === offerData.length - 1) {
        currentOfferIndex.setValue(0);
      } else {
        currentOfferIndex.setValue(currentOfferIndex.value + 1);
      }
    }
  });

  //Approve offers
  useKeypress(["q", "Q"], (event) => {
    // Ignore OS key-repeat: holding Alt+Q must not re-trigger approval.
    if (event.repeat) return;
    if (event.altKey) {
      if (!(isFetching || isSubmitting || isSubmitDisabled || isOfferAndIncentiveEmpty)) {
        const checkPrice = validatePrice({ offer_data: offerData, products_data: productData })
        if (!checkPrice.isValid) {
          setPriceWarningMessage(checkPrice.reason);
          setPriceWarningModelOpen(true);
        } else {
          handleApprove();
        }
      }
    }
  });

  //DNE offers
  useKeypress(["x", "X"], (event) => {
    if (event.altKey) {
      handleOpenModal();
    }
  });

  //SKIP offers--
  useKeypress(["e", "E"], (event) => {
    if (event.altKey) {
      handleSkipAdblock();
    }
  });

  //REJECT offers
  useKeypress(["r", "R"], (event) => {
    if (event.altKey) {
      handleReject();
    }
  });

  //refresh Suggestions
  useKeypress(["t", "T"], (event) => {
    if (event.altKey) {
      refreshAdblockSuggestions();
    }
  });

  const resolveBuilderScope = useCallback((target) => {
    if (offerBuilderRef.current && target && offerBuilderRef.current.contains(target)) {
      return offerBuilderRef.current;
    }
    if (incentiveBuilderRef.current && target && incentiveBuilderRef.current.contains(target)) {
      return incentiveBuilderRef.current;
    }
    return null;
  }, []);

  const collectFocusableElements = useCallback((scope, activeElement) => {
    if (!scope) {
      return [];
    }

    return Array.from(scope.querySelectorAll(focusableSelector.current)).filter((node) => {
      if (node.getAttribute("aria-hidden") === "true") {
        return false;
      }
      if (node.closest("[aria-hidden='true']")) {
        return false;
      }
      return node.offsetParent !== null || node === activeElement;
    });
  }, []);

  const focusScopeBoundary = useCallback((scope, reverse = false) => {
    const focusableElements = collectFocusableElements(scope);
    if (!focusableElements.length) {
      return false;
    }

    const targetElement = reverse
      ? focusableElements[focusableElements.length - 1]
      : focusableElements[0];

    if (!targetElement) {
      return false;
    }

    targetElement.focus();
    if (typeof targetElement.select === "function") {
      targetElement.select();
    }
    return true;
  }, [collectFocusableElements]);

  const handleBuilderTabNavigation = useCallback((event) => {
    const activeElement = document.activeElement;
    const scope = resolveBuilderScope(event.target);

    if (!scope) {
      return false;
    }

    const focusableElements = collectFocusableElements(scope, activeElement);

    if (!focusableElements.length) {
      return false;
    }

    const currentIndex = focusableElements.indexOf(activeElement);

    if (currentIndex === -1) {
      const fallbackIndex = event.shiftKey ? focusableElements.length - 1 : 0;
      const fallbackElement = focusableElements[fallbackIndex];
      fallbackElement.focus();
      if (typeof fallbackElement.select === "function") {
        fallbackElement.select();
      }
      return true;
    }

    const nextIndex = event.shiftKey ? currentIndex - 1 : currentIndex + 1;

    if (nextIndex < 0 || nextIndex >= focusableElements.length) {
      return false;
    }

    const nextElement = focusableElements[nextIndex];
    nextElement.focus();
    if (typeof nextElement.select === "function") {
      nextElement.select();
    }
    return true;
  }, [collectFocusableElements, resolveBuilderScope]);

  //Move to next field item, only if not in manual entry
  useKeypress(["Tab"], (event) => {
    if (handleBuilderTabNavigation(event)) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    if (event.shiftKey) {
      movePreviousField();
    } else {
      moveNextField();
    }
  });

  useKeypress(["b", "B"], (event) => {
    if (!event.altKey) {
      return;
    }

    event.preventDefault();

    if (activeField === "offer_text" && offerBuilderRef.current) {
      focusScopeBoundary(offerBuilderRef.current, event.shiftKey);
      return;
    }

    if (activeField === "incentive_text" && incentiveBuilderRef.current) {
      focusScopeBoundary(incentiveBuilderRef.current, event.shiftKey);
    }
  });

  return (
    <SkeletonTheme color="#202020" highlightColor="#444">
      <MainLayout>
        <Header>
          {isLoading ? (
            <div className="d-flex">
              <div className="my-auto">
                <Skeleton height={24} width={800} />
              </div>
            </div>
          ) : (
            <div className="d-flex row w-100">
              <div className="my-auto d-flex">
                  <>
                    <Link href="/circular" className="ml-1 my-auto">
                      Circulars
                    </Link>
                    <Link
                      href={`/circular/${currentCircularId}/${currentPageId}/${currentAdBlockId}`}
                      className="ml-2 my-auto"
                    >
                      {circularName}
                    </Link>
                  </>

                <PageDropDown
                  className="ml-3"
                  id={currentCircularId}
                  onSelectValue={onPageSelect}
                  value={currentPageId}
                  isVisible={userInfo?.user?.is_superuser || userInfo?.user?.is_moderator|| userInfo?.user?.is_active}
                />
                <PageType className="ml-2 my-auto">
                    {pageType}
                  </PageType>
                <AdBlockDropDown
                  className="ml-3"
                  id={currentPageId}
                  onSelectValue={handleAdblockSelect}
                  value={currentAdBlockId}
                  isVisible={userInfo?.user?.is_superuser || userInfo?.user?.is_moderator || userInfo?.user?.is_active}
                  adblockData={adblockData}
                  onLoad={onAdblockDataLoad}
                  disabled={isFetching}
                />
              </div>

              <PageInfo
                className="ml-auto my-auto "
                pageData={pageData}
                adblockData={adblockData}
              />
                <IconButton title="Reset Block" className="ml-2 my-auto"
                  onClick={() => { handleResetAdblock() }}
                >
                  <FaTrashRestore color="white" />
                </IconButton>
              {(!isLoading && currentAdblockData.similar_adblock_uuid && !currentAdblockData.has_children && !currentAdblockData.offers_approved) &&
                <Button
                  // buttonTheme={"dark"}
                  width="50px"
                  size="small"
                  className="ml-2 my-auto"
                  onClick={() => imageMatchingModal.openModal()}
                  isLoading={isSubmitting}
                  disabled={isFetching}
                  eventType="flag"
                >
                  <BsImageAlt />
                </Button>
              }
                <Popover
                  title="Add Review Notes"
                  trigger='click'
                  content={
                    <>
                      <Input.TextArea
                        rows={4}
                        placeholder="Add your review notes here..."
                        value={reviewNote}
                        onChange={(e) => setReviewNote(e.target.value)}
                      />
                      <AntBtn isLoading={isSubmitting} disabled={isFetching || !reviewNote} type="primary"
                        onClick={() => {
                          setIsSubmitting(true);
                          markAdblockToReview(currentAdBlockId, reviewNote).then(() => {
                            toast.info('Block is marked for review', {
                              position: "top-right", autoClose: 5000, closeOnClick: true,
                              pauseOnHover: true, progress: undefined, theme: "dark"
                            });
                            setReviewNote("");
                          }).finally(() => {
                            setIsSubmitting(false);
                          });
                        }}>REVIEW</AntBtn>
                    </>
                  }
                >
                  <Button buttonTheme={`${isDoNotEnter ? "warn" : "dark"}`}
                    width="auto"
                    size="small"
                    className="ml-2 my-auto"
                    isLoading={isSubmitting} disabled={isFetching}>REVIEW</Button>
                </Popover>
              <FlagButtonGroup
                isSubmitting={isSubmitting}
                isFetching={isSubmitting}
                onDoNotEnter={handleOpenModal}
                onSkip={handleSkipAdblock}
                onReject={handleReject}
                onApprove={() => {
                  const checkPrice = validatePrice({ offer_data: offerData, products_data: productData })
                  if (!checkPrice.isValid) {
                    setPriceWarningMessage(checkPrice.reason);
                    setPriceWarningModelOpen(true);
                  } else {
                    handleApprove();
                  }
                }}
                onNext={navigateNext}
                isDoNotEnter={isDoNotEnter}
                isSkipped={isSkipped}
                isRejected={isRejected}
                isApproved={isApproved}
                isAllOfferValid={allOffersValid}
                isSubmitDisabled={isSubmitDisabled || isOfferAndIncentiveEmpty || currentAdblockData.is_dupe}
                ShowNext={true}
              />
            </div>
          )}
        </Header>

        <Content>
          <div className="d-flex flex-column" style={{ width: "320px" }}>
            <AdblockLocation
              backImg={pageImg && `data:image/jpeg;base64,${pageImg}`}
              pageWidth={pageWidth}
              pageHeight={pageHeight}
              adblockCoords={adblockCoords}
              sectionCoords={sectionCoords}
            />
            <MetadataSection title="ADBLOCK DATA">
              <EventsDropDown
                pageId={currentPageId}
                {...events}
                onRefresh={refetchAdblocks}
                onChange={(e) => events.setValue(e)}
              />
              <MetaData className="mt-3" couponDisabled={couponDisabled} />
            </MetadataSection>
          </div>
          <AdblockImage
            type="offer"
            imageHeight={imageHeight}
            imageWidth={imageWidth}
            blockRef={blockRef}
            isFetching={isFetching}
            filename={adblockFilename}
            currentAdBlockData={currentAdblockData}
            circularId={currentCircularId}
            pageId={currentPageId}
            sizeData={sizeData}
          />
          <div className="d-flex flex-column">
            <OfferSelector
              title={`OFFERS & INCENTIVES ${
                currentOfferIndex.value +
                1 +
                (currentItemType === "incentive" ? currentInfo.index + 1 : 0)
              }/${offerData.length + incentiveData.length}`}
              max={offerData.length && productData.length}
              onChange={handleSplit}
              value={split}
              productData={productData}
              offerData={offerData}
              incentiveData={incentiveData}
              onAdd={handleAddItem}
              disableSubmit={(value) => setIsSubmitChildDisabled(value)}
              isAddable
            >
              {offerData.length === 0 && incentiveData.length === 0 ? (
                <EmptyOfferSelector
                  onCreateOffer={handleAddOffer}
                  onCreateIncentive={handleAddIncentive}
                />
              ) : (
                <div className="d-flex">
                  <ItemsList>
                    {offerData.map((offer, index) => (
                      <OfferItem
                        key={`offer${index}`}
                        className="d-flex flex-row"
                        active={
                          index === currentOfferIndex.value &&
                          currentItemType === "offer"
                        }
                        onClick={() => handleOfferSelect(index)}
                        onRemove={handleRemoveOffer}
                        onClone={(event, index) => handleCloneOffer(event, index)}
                        data={offer}
                        index={index}
                        adblockInfo={adblockInfo}
                      />
                    ))}
                    {incentiveData.map((incentive, index) => (
                      <IncentiveItem
                        key={`incentive${index}`}
                        className="d-flex flex-row"
                        active={
                          index === currentInfo.index &&
                          currentItemType === "incentive"
                        }
                        onClick={() => handleIncentiveSelect(index)}
                        onRemove={handleRemoveIncentive}
                        onClone={(event, index) => handleCloneIncentive(event, index)}
                        data={incentive}
                        index={index}
                        incentiveData={incentiveData}
                        isApproved={isApproved}
                        adblockInfo={adblockInfo}
                      />
                    ))}
                  </ItemsList>
                </div>
              )}
            </OfferSelector>
            <div
              className="d-flex flex-1"
              style={{ height: "calc(100% - 195px)" }}
            >
              <QuickSelection
                onRefreshSuggestion={() => refreshAdblockSuggestions()}
                isRefresh={adblockData.length > 0}
              >
                {isManualEntry && !isApproved && (
                  <ManualEntry onExit={() => setIsManualEntry(false)} />
                )}
                {((activeField === "offer_text" && isManualEntry) ||
                  (activeField === "offer_text" &&
                    currentSuggestions.length === 0)) && (
                  <div ref={offerBuilderRef} data-builder-scope="offer-text">
                    <OfferTextBuilder
                      type={currentInfo?.offer_type}
                      value={currentInfo?.offer_text}
                      existingOfferTextForSave={firstDefaultSaveOfferText}
                      view="offer"
                      onChange={(e) => {
                        updateOfferText(normalizeWPurchaseText(e));
                      }}
                      onStartChange={(e) => {
                        if (e) {
                          if ((pageType === "Coupon Page" && !isCouponAutoCheckExcluded(activeRetailer?.retailer_name)) || digitalCouponAppliedRef.current) {
                            const tempMetaData = metaData.map(a => { return { ...a } })
                            tempMetaData.find(a => a.key === "coupon_f").value = true;
                            tempMetaData.find(a => a.key === "coupon_f").coupon_amnt = e;
                            setMetaData(tempMetaData)
                          }
                        }
                      }}
                    />
                  </div>
                  )}
                {((activeField === "incentive_text" && isManualEntry) ||
                  (activeField === "incentive_text" &&
                    currentSuggestions.length === 0)) && (
                  <div ref={incentiveBuilderRef} data-builder-scope="incentive-text">
                    <IncentiveTextBuilder
                      type={currentInfo?.incentive_type}
                      value={currentInfo?.incentive_text}
                      onChange={(e) => {
                        updateInfo("incentive_text", normalizeWPurchaseText(e));
                      }}
                    />
                  </div>
                  )}
                {
                  //TODO: this part should have its own loading state
                  isFetching || suggestionsLoading ? (
                    <div>Loading...</div>
                  ) : offerData.length === 0 && incentiveData.length === 0 ? (
                    <div className="mt-4 pt-4 text-center">
                      No offer/incentive available
                    </div>
                  ) : (
                    <>
                      <div className="text-blue-light mb-3">
                        {activeOfferInfoText}
                      </div>

                      {isApproved ? (
                        <AdblockApproved />
                      ) : currentSuggestions &&
                        currentSuggestions.length > 0 ? (
                        <>
                          {!isManualEntry && (
                            <QuickSelectionChoice
                              index={0}
                              data={{
                                title: "Manual Entry",
                                value: "Manual",
                              }}
                              active={false}
                              showIndex={!isManualEntry}
                              onClick={handleSuggestionClick}
                            />
                          )}

                          {currentSuggestions
                            .slice(
                              0,
                              isManualEntry ? currentSuggestions.length : 9
                            )
                            .filter((item) => item.title)
                            .map((item, index) => (
                              <QuickSelectionChoice
                                key={`${index}key`}
                                showIndex={!isManualEntry}
                                index={index + (isManualEntry ? 0 : 1)}
                                data={item}
                                active={activeFieldValue === item.value}
                                onClick={handleSuggestionClick}
                              />
                            ))}
                        </>
                      ) : (
                        circularType === 'Training Circular' ?
                        <div
                            className="mt-4 text-center"
                            style={{
                              paddingTop: '180px',
                              color: '#aaa',
                              fontSize: '14px',
                            }}
                          >
                            <h3>Training Circular</h3>
                            <div className="mt-3">
                              Suggestions has been disabled for this circular.
                            </div>
                          </div> :
                          <>
                            <NoSuggestions />
                          </>

                      )}
                    </>
                  )
                }
              </QuickSelection>

              <InfoSection title={currentItemType === "incentive" ? "INCENTIVE INFORMATION" : "OFFER INFORMATION"} className="flex-1 flex-column">
                {currentItemType === "offer" ? (
                  <OfferInfo
                    key={'offerinfo-' + currentOfferIndex.value}
                    offerTypeData={offerTypeData}
                    useDefaultSaveOfferText={useDefaultSaveOfferText}
                    isLinerDisabled={isLinerDisabled}
                  />
                ) : currentItemType === "incentive" ? (
                  <IncentiveInfo />
                ) : (
                  <div className="mt-4 pt-4 text-center">No offers/incentives available</div>
                )}
                {parentRetailerName === "FSI" && (currentItemType === "offer" || currentItemType === "incentive") && (
                  <OfferInfoContainer className="mt-5" inputId="fsi_retailer_i">
                    <FsiRetailerLabel htmlFor="fsi_retailer_i">
                      Select Retailers for FSI
                    </FsiRetailerLabel>
                    <SearchByMultipleRetailer
                      func={getRetailerAutocompleteApi}
                      fsiRetailerIds={fsiRetailerIds}
                      containerStyle={{ padding: '0px', marginTop: '4px' }}
                      styles={{ width: '100%', padding: '0px' }}
                      placeholder="Select Retailers for FSI"
                      onSelect={handleSelectFsiRetailers}
                    />
                  </OfferInfoContainer>
                )}
              </InfoSection>
            </div>
          </div>
        </Content>
        <EndQueueModal
          {...endQueueModal}
          circularId={currentCircularId}
          goto="circular"
        />
        <OfferDeletionModal
          {...deleteOfferModal}
          adblockId={currentAdBlockId}
          pageId={currentPageId}
          onDelete={async (data) => {
            setOfferData(offerData.filter(item => item.uuid !== data));
            fetchAdBlock(currentAdBlockId, true);
          }}
          deletingOffer={deletingOffer}
        />
        {/* {imageMatchingModal.open &&  */}
          <ImageMatchingModal
            {...imageMatchingModal}
            sizeData={sizeData}
            currentAdBlockData={currentAdblockData}  
            circularName={circularName}
            dupe_block={currentAdblockData.similar_adblock_uuid}
            onSuccess={navigateNext}
            startTime={startTime}
            onImport={(data) => handleImport(data)}
            onError={(err) => toast.error(err)}
          />
        {/* } */}
        <ConfirmationModal
          isOpen={isConfirmationModalOpen}
          msgBody={confirmationMessage}
          onContinue={handleContinue}
          onCancel={handleCancelConfirmation}
        ></ConfirmationModal>
        <NetUnitPriceModal
          isVisible={showNetUnitPriceModal}
          calculatedValues={netUnitPriceValue}
          onConfirm={() => {
            setShowNetUnitPriceModal(false);
            handleApprove({ force: true, skipValidation: false, skipCraftBeerCheck: true });
          }}
          onCancel={() => {
            setShowNetUnitPriceModal(false);
            setIsSubmitting(false);
            setIsSubmitDisabled(true);
          }}
        />
      <Modal
        title="Price Warning"
        open={priceWarningModelOpen}
        okText="Override and Approve"
        onOk={async () => {
          const res = await overrideAdblock(currentAdBlockId);
          if (res.success) {
            handleApprove({ skipCraftBeerCheck: true });
            setPriceWarningModelOpen(false);
          }
        }}
        onCancel={() => setPriceWarningModelOpen(false)}
        style={{
          top: 0,
          right: 0,
          position: 'absolute',
        }}
      >
        {priceWarningMessage}
      </Modal>
      <Modal
        title="Large Save Offer Validation Error"
        open={largeSaveOfferModalOpen}
        okText="Override and Approve"
        onOk={async () => {
          const res = await overrideAdblock(currentAdBlockId);
          if (res.success) {
            handleApprove({ skipCraftBeerCheck: true });
            setLargeSaveOfferModalOpen(false);
          }
        }}
        onCancel={() => setLargeSaveOfferModalOpen(false)}
        style={{
          top: 0,
          right: 0,
          position: 'absolute',
        }}
      >
        {largeSaveOfferMessage}
      </Modal>
      <Modal
        title="AdBlock Validation"
        open={showAdblockValidationModal}
        okText="Override and Approve"
        onOk={async () => {
          const res = await overrideAdblock(currentAdBlockId);
          if (res.success) {
            handleApprove({ force: true, skipValidation: true, skipCraftBeerCheck: true });
            setShowAdblockValidationModal(false);
          }
        }}
        onCancel={() => setShowAdblockValidationModal(false)}
        style={{
          top: 0,
          right: 0,
          position: 'absolute',
        }}
      >
        {adblockValidationMessage}
      </Modal>
      <Modal
        title="Methodology Reminder"
        open={craftBeerBogoModalOpen}
        okText="Approve Anyway"
        cancelText="Go Back"
        onOk={() => {
          setCraftBeerBogoModalOpen(false);
          handleApprove({ skipCraftBeerCheck: true });
        }}
        onCancel={() => setCraftBeerBogoModalOpen(false)}
        style={{
          top: 0,
          right: 0,
          position: 'absolute',
        }}
      >
        <div style={{ whiteSpace: 'pre-line' }}>
          {CRAFT_BEER_BOGO_MESSAGE.split(/(https?:\/\/[^\s]+)/g).map((part, i) =>
            /^https?:\/\//.test(part) ? (
              <a key={i} href={part} target="_blank" rel="noopener noreferrer">{part}</a>
            ) : (
              part
            )
          )}
        </div>
      </Modal>
      <SpaceAfterSlashWarningModal
        open={spaceWarningModalOpen}
        message={spaceWarningMessage}
        onClose={() => setSpaceWarningModalOpen(false)}
      />
      </MainLayout>
      <ToastContainer />
    </SkeletonTheme>
  );
};

const Content = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  overflow: hidden;
`;

const PageType = styled.div`
  padding: 5px;
`;

const MetadataSection = styled(Card)`
  min-width: 240px;
  flex: 1;
  overflow:auto;
`;

const Header = styled.div`
  height: 75px;
  color: white;
  font-size: 14px;
  display: flex;
  padding: 0 24px;
  background: ${(props) => props.theme.palette.backgrounds};
  margin-bottom: 1px;
`;

const ItemsList = styled.div`
  width: 100%;
  overflow: auto;
  max-height: 120px;
  ::-webkit-scrollbar {
    width: 14px;
    background: ${(props) => props.theme.palette.backgrounds};
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: ${(props) => props.theme.palette.backgrounds};
    border: 1px solid ${(props) => props.theme.palette.itemsHover};
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.palette.itemsHover};
    cursor: pointer;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
    cursor: pointer;
  }
`;

const IconButton = styled.span`
  cursor: pointer;
  margin: 0 4px;
  &:hover {
    svg {
      transition: all 0.3s ease;
      fill: ${(props) => props.theme.palette.primary} !important;
    }
  }
`;

const FsiRetailerLabel = styled.label`
  font-size: ${(props) => props.theme.font.size.s};
  color: ${(props) => props.theme.palette.secondary};
  display: flex;
  margin-bottom: 0;
`;


const InfoSection = styled(props => <Card {...props}/>)`
  height: calc(100% - 4px);
  flex: 1;
  color: white;
  width: 380px;
  .offer-label {
    color: white;
    font-size: 24px;
  }
`;